/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by maximeallex on 2018-04-11.
 */


'use strict';
import { Directive, ElementRef, HostListener, Input, Type } from '@angular/core';
import { LKContextMenuService } from './service';
import {TooltipService} from "../tooltip/service";

@Directive({
  selector: '[contextMenu]',
})
export class LKContextMenuDirective {

  @Input() private contextMenu: Type<any>;
  @Input() private props: {[key: string]: any};
  @Input() private event: 'click'|'contextmenu'|'mouseover' = 'click';
  @Input() private autoClose?: boolean = true;
  @Input() private arrowed?: boolean;
  @Input() private menuWidth?: number;
  @Input() private menuHeight?: number;
  @Input() private cross?: boolean;
  @Input() private curtain?: boolean = true;
  @Input() private position?: 'top'|'bottom'|'left'|'right'|'relative';

  constructor(
    private _service: LKContextMenuService,
    private _element: ElementRef,
    private _tooltipService: TooltipService
  ) {
  }

  /**
   * Dispatch event to open context menu from click
   */
  @HostListener('click', ['$event'])
  private onClick(e: MouseEvent): void {
    if ( this.event === 'click' ) {
      this.triggerMenu(e);
    }
  }

  /**
   * Dispatch event to open context menu from right-click
   */
  @HostListener('contextmenu', ['$event'])
  private onContextmenu(e: MouseEvent): void {
    if ( this.event === 'contextmenu' ) {
      this.triggerMenu(e);
    }
  }

  /**
   * Dispatch event to open context menu from right-click
   */
  @HostListener('mouseover', ['$event'])
  private onCHover(e: MouseEvent): void {
    if ( this.event === 'mouseover' ) {
      this.triggerMenu(e);
    }
  }

  /**
   * Update stream of context menu event
   */
  private triggerMenu(e: MouseEvent): void {
    e.preventDefault();
    e.stopPropagation();
    this._tooltipService.close();
    this._service.open(
      this.contextMenu,
      e,
      this.props,
      this.menuWidth ||Â 250,
      this.menuHeight ||Â 250,
      this.curtain,
      this.arrowed,
      this.cross,
      !this.autoClose,
      this._element.nativeElement,
      this.position
    );
  }
}
